goog.provide("shadow.js.shim.module$$mui$material$AccordionSummary$default");
shadow.js.shim.module$$mui$material$AccordionSummary$default = shadow.js.shim.module$$mui$material$AccordionSummary.default;
